import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formDefinitionKeys } from '@/lib/queryKeys';
import type { FormDefinition } from '@/types/appointmentForm';

export function useFormDefinition(id: string | undefined) {
  return useApiQuery<FormDefinition>({
    queryKey: formDefinitionKeys.detail(id ?? ''),
    queryFn: () =>
      apiGet<FormDefinition>(operationsClient, appointmentFormEndpoints.definition(id as string)),
    enabled: Boolean(id),
    showErrorToast: false,
  });
}
